import { Row, Col } from 'react-bootstrap';
import SimpleTableComponent from './SimpleTableComponent'

const DetailsComponent = (props) => {

  if(props.data?.errors) {
   delete props.data.errors;
  }

  const createKey = (hash) => {
    return hash.split("_").join(" ");
  }

  const createDetailsComponent = () => {
    const keys = Object.keys(props.data)
    const totalFields = keys.length
    const rows = []
    let tableComponent = []
    let col = []
    for (let i = 0; i < totalFields; i++) {
      if(props.data[keys[i]] == null || props.data[keys[i]] == undefined || props.data[keys[i]] == "") continue
      if(props.data[keys[i]] && props.data[keys[i]].constructor === Array && props.data[keys[i]].length > 0) {
        if(props.data[keys[i]][0].constructor === Object) {
          tableComponent.push(<Col key={i}><SimpleTableComponent
            data={props.data[keys[i]]}
            heading={createKey(keys[i])}
          /></Col>)
        } else {
          col.push(<Col key={`${i}_cp_details_col`} style={{ overflowWrap: "break-word", maxWidth: `${100 / props.rowCount}%`, overflow: 'auto' }} className="d-flex  pt-2 m-1 rounded-top bg-light">
            <>
              <span style={{ textTransform: "capitalize" }} className="fw-bold p-1 w-30">{createKey(keys[i])}</span>
              {props.data[keys[i]].map((val)=> `▪ ${val} `)}
            </>
          </Col>)
        }
      } else {
        if(props.data[keys[i]] === null){
          col.push(<Col key={`${i}_cp_details_col`} style={{ overflowWrap: "break-word", maxWidth: `${100 / props.rowCount}%`, overflow: 'auto' }} className="d-flex  pt-2 m-1 rounded-top bg-light">
            <>
              <span style={{ textTransform: "capitalize" }} className="fw-bold w-30">{createKey(keys[i])}</span>
              <span className="text-left w-60">Null</span>
            </>
          </Col>)
        } else if(props.data[keys[i]] === true){
          col.push(<Col key={`${i}_cp_details_col`} style={{ overflowWrap: "break-word", maxWidth: `${100 / props.rowCount}%`, overflow: 'auto' }} className="d-flex  pt-2 m-1 rounded-top bg-light">
            <>
              <span style={{ textTransform: "capitalize" }} className="fw-bold w-30">{createKey(keys[i])}</span>
              <span className="text-left w-60">True</span>
            </>
          </Col>)
        } else if(props.data[keys[i]] === false){
          col.push(<Col key={`${i}_cp_details_col`} style={{ overflowWrap: "break-word", maxWidth: `${100 / props.rowCount}%`, overflow: 'auto' }} className="d-flex  pt-2 m-1 rounded-top bg-light">
            <>
              <span style={{ textTransform: "capitalize" }} className="fw-bold w-30">{createKey(keys[i])}</span>
              <span className="text-left w-60">False</span>
            </>
          </Col>)
        }  else if(props.data[keys[i]] === "" || props.data[keys[i]].length === 0){
          col.push(<Col key={`${i}_cp_details_col`} style={{ overflowWrap: "break-word", maxWidth: `${100 / props.rowCount}%`, overflow: 'auto' }} className="d-flex  pt-2 m-1 rounded-top bg-light">
            <>
              <span style={{ textTransform: "capitalize" }} className="fw-bold w-30">{createKey(keys[i])}</span>
              <span className="text-left w-60">- -</span>
            </>
          </Col>)
        } else {
          if(props.data[keys[i]].constructor === Object){
            tableComponent.push(<Col key={i}><SimpleTableComponent
              data={[props.data[keys[i]]]}
              heading={createKey(keys[i])}
            /></Col>)
          } else {
            col.push(<Col key={`${i}_cp_details_col`} style={{ overflowWrap: "break-word", maxWidth: `${100 / props.rowCount}%`, overflow: 'auto' }} className="d-flex  pt-2 m-1 rounded-top bg-light">
              <>
                <span style={{ textTransform: "capitalize" }} className="fw-bold w-30">{createKey(keys[i])}</span>
                <span className="text-left px-3 w-70">{props.data[keys[i]]}</span>
              </>
            </Col>)
          }
        }
      }

      if(col.length === props.rowCount) {
        rows.push(<Row className="d-flex justify-content-start" key={`${i}_cp_details_col`}>{col}</Row>)
        col = []
      }
    }
    rows.push(<Row className="d-flex justify-content-start" key={`$more_details_col`}>{col}</Row>)
    rows.push(<Row className="d-flex justify-content-start mt-3" key={`$more_details_table`}>{tableComponent}</Row>)
    return rows
  }

  return <div className="my-1 mx-3">
    {createDetailsComponent()}
  </div>
}

DetailsComponent.defaultProps = {
  data: {},
  rowCount: window.innerWidth < 960 ? window.innerWidth < 568 ? 1 : 2 : 3,
}

export default DetailsComponent;
